import { COMMON_DATE_FORMAT } from 'constants/date';
import { FieldInputType } from 'constants/fields';

export const fundingInformationFields = {
  fundingInfoWarehouseBankId: {
    contentValueClassName: 'truncate',
    label: 'Warehouse Bank:',
    name: 'fundingInfoWarehouseBankId',
    type: FieldInputType.TEXT,
  },
  commitmentNumber: {
    contentValueClassName: 'truncate',
    label: 'Commitment #:',
    name: 'commitmentNumber',
    type: FieldInputType.TEXT,
  },
  type: {
    contentValueClassName: 'truncate',
    label: 'Type:',
    name: 'type',
    type: FieldInputType.TEXT,
  },
  fundingConfirmationNumber: {
    contentValueClassName: 'truncate',
    label: 'Funding Confirmation Number:',
    name: 'fundingConfirmationNumber',
    type: FieldInputType.TEXT,
  },
  fundingInfoWireAmount: {
    contentValueClassName: 'truncate',
    label: 'Wire Amount:',
    name: 'fundingInfoWireAmount',
    type: FieldInputType.CURRENCY,
  },
  wireComments: {
    label: 'Wire Comments:',
    name: 'wireComments',
    type: FieldInputType.TEXT,
  },
  wirePostedDate: {
    contentValueClassName: 'truncate',
    label: 'Wire Posted Date:',
    name: 'wirePostedDate',
    type: FieldInputType.DATE,
    format: COMMON_DATE_FORMAT,
    options: { includeLocalOffset: true },
  },
  curtailment: {
    contentValueClassName: 'truncate',
    label: 'Curtailment:',
    name: 'curtailment',
    type: FieldInputType.TEXT,
  },
  warehouseFundingOrdered: {
    contentValueClassName: 'truncate',
    label: 'Warehouse Funding Ordered:',
    name: 'warehouseFundingOrdered',
    type: FieldInputType.DATE,
    format: COMMON_DATE_FORMAT,
    options: { includeLocalOffset: true },
  },
};

export const closingAgentFields = {
  companyName: {
    contentValueClassName: 'truncate',
    label: 'Company Name:',
    name: 'companyName',
    type: FieldInputType.TEXT,
  },
  closingAgentFeeProviderFullAddress: {
    contentValueClassName: 'truncate',
    label: 'Company Address:',
    name: 'closingAgentFeeProviderFullAddress',
    type: FieldInputType.TEXT,
  },
  bank: {
    contentValueClassName: 'truncate',
    label: 'Bank:',
    name: 'bank',
    type: FieldInputType.TEXT,
  },
  cityAndState: {
    contentValueClassName: 'truncate',
    label: 'City, State:',
    name: 'cityAndState',
    type: FieldInputType.TEXT,
  },
  closingAgentABANumber: {
    contentValueClassName: 'truncate',
    label: 'ABA Number:',
    name: 'closingAgentABANumber',
    type: FieldInputType.TEXT,
  },
  closingAgentAccountNumber: {
    contentValueClassName: 'truncate',
    label: 'Account Number:',
    name: 'closingAgentAccountNumber',
    type: FieldInputType.TEXT,
  },
  referenceNumber: {
    contentValueClassName: 'truncate',
    label: 'Reference #:',
    name: 'referenceNumber',
    type: FieldInputType.TEXT,
  },
  closingAgentContact: {
    contentValueClassName: 'truncate',
    label: 'Contact:',
    name: 'closingAgentContact',
    type: FieldInputType.TEXT,
  },
};

export const wireToInformationFields = {
  wireToInfoWarehouseBankId: {
    contentValueClassName: 'truncate',
    label: 'Warehouse Bank:',
    name: 'wireToInfoWarehouseBankId',
    type: FieldInputType.TEXT,
  },
  wireNumber: {
    contentValueClassName: 'truncate',
    label: 'Wire Number:',
    name: 'wireNumber',
    type: FieldInputType.TEXT,
  },
  fedReferenceNumber: {
    contentValueClassName: 'truncate',
    label: 'Fed Reference Number:',
    name: 'fedReferenceNumber',
    type: FieldInputType.TEXT,
  },
  wireToInfoWireAmount: {
    contentValueClassName: 'truncate',
    label: 'Wire Amount:',
    name: 'wireToInfoWireAmount',
    type: FieldInputType.CURRENCY,
  },
  advanceAmountPercent: {
    contentValueClassName: 'truncate',
    label: 'Advance Amount %:',
    name: 'advanceAmountPercent',
    type: FieldInputType.PERCENTAGE,
  },
  advanceAmount: {
    contentValueClassName: 'truncate',
    label: 'Advance Amount:',
    name: 'advanceAmount',
    type: FieldInputType.CURRENCY,
  },
  addAdvanceAmount: {
    contentValueClassName: 'truncate',
    label: 'Add Advance Amount:',
    name: 'addAdvanceAmount',
    type: FieldInputType.CURRENCY,
  },
};

export const furtherCreditToInformationFields = {
  furtherCreditToABANumber: {
    contentValueClassName: 'truncate',
    label: 'ABA Number:',
    name: 'furtherCreditToABANumber',
    type: FieldInputType.TEXT,
  },
  furtherCreditToAccountNumber: {
    contentValueClassName: 'truncate',
    label: 'Account Number:',
    name: 'furtherCreditToAccountNumber',
    type: FieldInputType.TEXT,
  },
  furtherCreditToContact: {
    contentValueClassName: 'truncate',
    label: 'Contact:',
    name: 'furtherCreditToContact',
    type: FieldInputType.TEXT,
  },
};
